export function clearSlashes(str: string): string {
  return str.replace(/\/$/, '').replace(/^\/+/, '');
}

export function isFirstLevel(url: string): boolean {
  url = clearSlashes(url);
  return url.split('/').length === 1;
}

export function isRootPopular(url: string): boolean {
  url = clearSlashes(url);
  // Да, завязываемся но то что популярное будет называться именно так. Иначе нам его не опознать.
  return url.split('/').length === 2 && url.split('/')[1] === 'populiarnoe';
}

export function isNumeric(value: string): boolean {
  return /^-{0,1}\d+$/.test(value);
}
